import { Row, Col } from "reactstrap";
import { AudioUrl } from "../../libs/env";


export const SpeakerTest = ({speakerClass}) => {
  return (
    <Row className={`p-4 sm-py-2 f-13 ${speakerClass} `}>
      <Col md={4} className="sfw-700">Play the recording to test your speakers:</Col>
      <Col className="sm-center">
        <audio
          className="audio-size"
          controls
          controlsList="noplaybackrate nodownload"
        >
          <source src={`${AudioUrl}/audio_test.mp3`} />
        </audio>
      </Col>
    </Row>
  );
};
